import { ChangeDetectionStrategy, ChangeDetectorRef, Component, DestroyRef, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormInputComponent } from "../../utils/form-input/form-input.component";
import { MdbButtonComponent } from "../../utils/mdb-button/mdb-button.component";
import { AbstractControl, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from "@angular/forms";
import { TranslateModule } from "@ngx-translate/core";
import { AuthWrapperComponent } from "../auth-wrapper/auth-wrapper.component";
import { AuthService } from "../../../services/auth/auth.service";
import { CustomNotificationService } from "../../../services/utils/custom-notification.service";
import { RouterLink } from "@angular/router";
import { finalize } from "rxjs";
import { HttpErrorResponse } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
import { HttpErrorsService } from "../../../services/utils/http-errors.service";

@Component({
    selector: 'app-password-forgotten',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        FormInputComponent,
        MdbButtonComponent,
        ReactiveFormsModule,
        TranslateModule,
        AuthWrapperComponent,
        RouterLink
    ],
    templateUrl: './password-forgotten.component.html',
    styleUrl: './password-forgotten.component.scss'
})
export class PasswordForgottenComponent {
  loading: boolean = false
  formGroup: FormGroup = this.formBuilder.group({
    email: [null, [Validators.required, Validators.email]]
  })

  private readonly destroyRef = inject(DestroyRef);

  constructor(private formBuilder: FormBuilder,
              private authService: AuthService,
              private notificationService: CustomNotificationService,
              private httpErrorService: HttpErrorsService,
              private cdr: ChangeDetectorRef) {
  }

  getFormControl(name: string): AbstractControl | null {
    return this.formGroup.get(name)
  }

  submit() {
    this.formGroup.markAllAsTouched()

    if(this.formGroup.invalid)
      return

    this.loading = true
    this.authService.forgotPassword(this.getFormControl('email')?.value)
      .pipe(
        finalize(() => {
          this.loading = false
          this.cdr.markForCheck()
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe({
        next: () => {
          this.notificationService.success("AUTH.RESET_LINK_SENT")
        },
        error: (e: HttpErrorResponse) => {
          this.httpErrorService.handleError(e)
        }
      })
  }

  protected readonly environment = environment;
}
